<script>
import AkButtonActionV2 from '@components/v2/general/AkButtonActionV2.vue';
import {PerfectScrollbar} from 'vue3-perfect-scrollbar';

export default {
  name: 'GaBaseExpandedFilter',
  components: {PerfectScrollbar, AkButtonActionV2},
  props: {
    title: {
      type: String,
      required: true,
    },
    nbSelected: {
      type: Number,
      required: false,
      default: 0,
    },
    canGoBack: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  emits: ['back', 'reset', 'apply'],
  computed: {
    applyLabel() {
      if (!this.canGoBack) return 'Appliquer';
      if (!this.nbSelected) return 'Valider';
      return `Valider (${this.nbSelected})`;
    },
  },
};
</script>

<template>
  <div
    class="px-8 py-6 flex sticky border-grey-100 border-b gap-3 items-center h-[86px]"
    :class="{'justify-between': !canGoBack}">
    <button v-if="canGoBack" @click="$emit('back')" class="p-2 rounded-md border border-grey-100 text-grey-900">
      <i class="ga-icon ga-chevron_left text-lg" />
    </button>
    <span class="text-[18px] font-semibold text-grey-900">
      {{ title }}
    </span>
    <button v-if="!canGoBack" @click="$emit('back')">
      <i class="ga-icon ga-supprimer text-3xl text-grey-900" />
    </button>
  </div>
  <perfect-scrollbar :options="{suppressScrollX: true}" class="md:grow-0 grow">
    <slot name="default" />
  </perfect-scrollbar>
  <div class="border-t border-grey-100 px-8 py-6 flex gap-2">
    <AkButtonActionV2 label="Tout effacer" @click="$emit('reset')" class="font-medium btn-secondary !h-[48px] w-1/2" />
    <AkButtonActionV2 :label="applyLabel" @click="$emit('apply')" class="font-medium btn-primary !h-[48px] w-1/2" />
  </div>
</template>

<style scoped></style>
